import { isTomorrow, isToday } from 'date-fns';

import { WEEK_DAYS_SHORT, WEEK_DAYS, MONTHS_SHORT } from './components/date-chips/constants';

export const prepareDate = (date: string) => {
    const day = new Date(date).getDate();
    const dayNumber = new Date(date).getDay();

    const month = new Date(date).getMonth();
    const isDateToday = isToday(new Date(date));
    const isDateTomorrow = isTomorrow(new Date(date));

    let dayLabelFull;

    switch (true) {
        case isDateToday:
            dayLabelFull = 'Сегодня';
            break;

        case isDateTomorrow:
            dayLabelFull = 'Завтра';
            break;

        default:
            dayLabelFull = WEEK_DAYS[dayNumber];
    }

    return {
        day: day,
        monthLabel: MONTHS_SHORT[month],
        dayLabelFull: dayLabelFull,
        dayLabelShort: WEEK_DAYS_SHORT[dayNumber],
    };
};

const EMPTY_MESSAGE = 'Поле обязательно для заполнения';

export const validateNotEmpty =
    (message = EMPTY_MESSAGE) =>
    (value?: string | number) => {
        const validValue = value === undefined ? undefined : String(value).trim();

        if (!validValue) return message;
    };
